/* eslint-disable no-underscore-dangle */
import { useMemo } from 'react';
import {
} from '@modules/opportunities/presentation/routes';
import { ProposalEntity, ProposalStatus } from '@modules/clients/entities/client/api/dto/clientProposal.dto';
import {
  ProposalCreationBankProductsRoute, ProposalCreationClientAndMortgageRoute, ProposalCreationConfiguratorRoute
} from '@modules/proposals/presentation/routes';
import { ProposalCreationEngine } from './useProposalCreationStateMachineEngine';

const useComputeProposalCreationState = ({ proposal }: {
  proposal?: ProposalEntity,
}) => {
  const STATE_MACHINE = useMemo(
    (): ProposalCreationEngine.StateMachine => ({
      [ProposalCreationClientAndMortgageRoute.to]: {
        isAccessible: !!proposal?.id,
        isComplete: !!proposal?.loan_amount && !!proposal.transaction_type,
      },
      [ProposalCreationBankProductsRoute.to]: {
        isAccessible: !!proposal?.loan_amount && !!proposal.transaction_type,
        isComplete: !!proposal?.bank_offers?.length,
      },
      [ProposalCreationConfiguratorRoute.to]: {
        isAccessible: !!proposal?.bank_offers?.length
          && proposal.status === ProposalStatus.GENERATED,
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [proposal]
  );

  return { STATE_MACHINE };
};

export default useComputeProposalCreationState;
